<script>
    import Time from "svelte-time";
    import ThumbnailComponent from "./Files/ThumbnailComponent.svelte";
    import GalleryComponent from "./Files/GalleryComponent.svelte";
    import DownloadsComponent from "./Files/DownloadsComponent.svelte";
    import FormComponent from "./Forms/FormComponent.svelte";
    import MapComponent from "./Maps/MapComponent.svelte";
    import CommentsComponent from "./Comments/CommentsComponent.svelte";
    import EmbeddableProductOffers from "./EmbeddableComponents/EmbeddableProductOffers.svelte";
    import EmbeddableLatestNews from "./EmbeddableComponents/EmbeddableLatestNews.svelte";

    export let config;
    export let content;

</script>


<article class="px-0 py-2 mb-3 bg-transparent">

    <div class="mb-4 pb-0 text-center">
        <h2 class="mb-3 site-header">
            {#if content.ctype === "FORM_CONTENT"}
                <i class="fas fa-pencil-alt me-1"></i>
            {:else if content.ctype === "MAP_CONTENT"}
                <i class="fas fa-map-marker me-1"></i>
            {/if}
            {@html content.cname}</h2>
<!--        <p>-->
<!--            <small class="text-muted">{content.cauthor},</small>-->
<!--            <small class="text-muted"><Time timestamp="{content.ctimestamp}" format="DD.MM.YYYY" /></small>-->
<!--        </p>-->
    </div>

    <div class="row">

        <div class="col">

            <p class="text-center">{@html content.ctext}</p>

            {#if content.ctype === "TEXT_CONTENT"}

                <DownloadsComponent {config} contentID="{content.cid}" />
                <GalleryComponent {config} contentID="{content.cid}" />

            {:else if content.ctype === "LINKED_COMPONENT"}

                {#if content.clinkedcomponent === "EmbeddableProductOffers"}
                    <EmbeddableProductOffers mname="Angebote" mid="103" {config} onlyFeatured={true} />
                {:else if content.clinkedcomponent === "EmbeddableLatestNews"}
                    <EmbeddableLatestNews {config} />
                {/if}

            {:else if content.ctype === "FORM_CONTENT"}

                <FormComponent {config} cid="{content.cid}" form_name="{content.cname}" />

            {:else if content.ctype === "MAP_CONTENT"}

                <MapComponent {config} cid="{content.cid}" />

            {/if}

        </div>

        <ThumbnailComponent {config} contentID="{content.cid}" listView={false} classes="{{placeholder: 'thumbnail_background_detail_view', thumbnail: 'file_thumbnail_detail_view col-md-4 order-first order-md-last mb-4'}}" />


    </div>

        {#if content.ccomments_active === "1"}
            <CommentsComponent {config} cid="{content.cid}" />
        {/if}

</article>



<style>
    :global(.thumbnail_background_detail_view) {
        display: none !important;
    }

    :global(.file_thumbnail_detail_view img) {
        width: 100%;
        object-fit: cover;
    }

    :global(.border-lightdark) {
        border-color: #666 !important;
    }
</style>
